import { observer } from 'mobx-react';
import { Button, CircularProgress } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { useState } from 'react';
import { useAuth } from '../stores';
import UserCompany from '../model/UserCompany';

interface Props {
  companyKey: string;
}

const AddCompanyButton = observer((props: Props) => {
  const { companyKey } = props;
  const [loading, setLoading] = useState(false);

  const auth = useAuth();

  if (!auth.userCompanies?.find) {
    return null;
  }

  return auth.userCompanies.find((company: UserCompany) => company.key === companyKey) ? (
    <Button
      variant="contained"
      className="btn btn-primary btn-lg"
      startIcon={<StarIcon />}
      onClick={async () => {
        setLoading(true);
        auth.removeFromUserCompanies(companyKey).finally(() => setLoading(false));
      }}
      disabled={loading}
    >
      {loading ? <CircularProgress color="success" size={20} /> : 'Ta bort favorit'}
    </Button>
  ) : (
    <Button
      variant="contained"
      className="btn btn-primary btn-lg"
      startIcon={<StarBorderIcon />}
      onClick={async () => {
        setLoading(true);
        auth.addToUserCompanies(companyKey).finally(() => setLoading(false));
      }}
      disabled={loading}
    >
      {loading ? <CircularProgress color="success" size={20} /> : 'Favorit'}
    </Button>
  );
});

export default AddCompanyButton;
